module.exports = __webpack_public_path__ + "img/content_title7.5edc6e53.png";